var map = {
	"./010_DSC0391.jpg": 80,
	"./020-_DSC8903.jpg": 81,
	"./04-_DSC9128.jpg": 82,
	"./05_DSC8904.jpg": 83,
	"./06-_DSC0311.jpg": 84,
	"./08-_DSC7392.jpg": 85,
	"./10-_DSC6805.jpg": 86,
	"./11_DSC5611.jpg": 87
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 28;